import { Typography } from '@material-ui/core';
import { Error } from '@material-ui/icons';
import { ColorDynamic, Inline } from '@superdispatch/ui';
import { AnchorButton } from '@superdispatch/ui-lab';
import { useLocation } from 'react-router-dom';
import { useNotification } from 'shared/layout/notification-stack/data/NotificationAPI';
import { LinkButton } from 'shared/routing/Links';
import styled from 'styled-components';

interface SubscriptionPaymentBannerProps {
  isLoadboard?: boolean;
}

const Container = styled.div`
  padding: 16px 24px;
  background-color: ${ColorDynamic.Red500};
  color: ${ColorDynamic.White};
`;

const Title = styled.span`
  font-weight: 600;
`;

export function SubscriptionPaymentBanner({
  isLoadboard,
}: SubscriptionPaymentBannerProps) {
  const { pathname } = useLocation();
  const isPaymentFailed = !!useNotification('subscription_payment_failed');

  if (!isPaymentFailed || pathname.startsWith('/settings/subscription')) {
    return null;
  }

  return (
    <Container>
      <Inline space="small" verticalAlign="center" horizontalAlign="center">
        <Inline space="xsmall" verticalAlign="center">
          <Error />
          <Typography color="inherit">
            <Title>Pay your past-due to keep your access.</Title> We tried
            several times and couldn&apos;t collect your payment. Your account
            will be paused soon.
          </Typography>
        </Inline>

        {isLoadboard ? (
          <AnchorButton
            size="small"
            variant="neutral"
            href="/tms/settings/subscription/pay_past_due"
          >
            Retry Payment
          </AnchorButton>
        ) : (
          <LinkButton
            size="small"
            variant="neutral"
            to="/settings/subscription/pay_past_due"
          >
            Retry Payment
          </LinkButton>
        )}
      </Inline>
    </Container>
  );
}
